<template>
     <el-dialog
          title="请重新登录"
          :visible.sync="isShow"          
          :before-close="hide">
          <el-form :model="loginForm" ref="loginForm" label-position="left" label-width="0px" class="demo-ruleForm login-container">
              <el-form-item prop="account">
              <el-input type="text" v-model="loginForm.account" auto-complete="off" placeholder="账号" @keyup.native.13="doLogin"></el-input>
              </el-form-item>
              <el-form-item prop="password">
              <el-input type="password" v-model="loginForm.password" auto-complete="off" placeholder="密码" @keyup.native.13="doLogin"></el-input>
              </el-form-item>
              <el-form-item style="width:100%;">
              <el-button type="primary" style="width:100%;" @click.native.prevent="doLogin" :loading="isLoading">登录</el-button>
              <span class="error-text">{{errorMsg}}</span>
              </el-form-item>
          </el-form> 
     </el-dialog>
        
</template>

<script>

import * as Urls from '../helper/Urls';
import * as VueHelper from '../helper/VueHelper';
import axios from 'axios';

import allMenu from '../menu/allMenu';
import commonMenu from '../menu/menu';
import MenuUtils from '@/utils/MenuUtils'

  export default {
    
    data() {
      return {
        isShow: false,
        isLoading: false,
        loginForm: {
          account: '',
          password: ''
        },
        errorMsg: '', 
      };
    },
    mounted(){
    },
    methods: {

        show(){
            this.isShow = true;
        },
        hide(){
            this.isShow = false;
        },      
        doLogin() {
        
            let inst = this;
            inst.isLoading = true;

            let url = Urls.user_login;
            let params = VueHelper.makeSearchParams({
                account: this.loginForm.account, 
                password: this.loginForm.password, 
                from_global_modal: 'N', 
            });

            axios.post(url, params).then(function (response) {
                inst.isLoading = false;
                
                let server_data = response.data;
                if(server_data.error){
                    inst.errorMsg = server_data.error;
                    return;
                }
                inst.errorMsg = '';
                sessionStorage.setItem('user',JSON.stringify(server_data.data));
                
                let role = server_data.data.roleValue;
                console.log("role:"+role);
                // 获取前端的角色的菜单权限
                // let menu = allMenu[role] || [];
                // menu = menu.concat(commonMenu);
                let menu = commonMenu;
                //拼接后台提供的列表路由
                let roleMeun = server_data.data.roleMeun;
                let menuData = [];
                
                roleMeun.forEach((element,index) => {
                  if(!element.children.length && element.workBenchList.length){//菜单有一级
                      menuData.push({
                          path:'/p'+index,
                          component: "HomeView",
                          redirect: element.workBenchList[0].benchPath,
                          name: element.menuName,
                          parent:true,
                          children:[
                              {
                                  pageAddress:element.workBenchList[0].benchComponent,
                                  path:element.workBenchList[0].benchPath,
                                  name:element.menuName
                              }
                          ]
                      })
                  }else if(!element.children[0].children.length){//菜单有二级
                      let data = {
                          path:'/p'+index,
                          redirect: '',
                          component: "HomeView",
                          name: element.menuName,
                          icon: element.menuIcon,
                          parent:true,
                          children:[]
                      };
                       element.children.forEach((element2,index2) => {
                          if(!element2.workBenchList.length)return;
                          data.children.push({
                              pageAddress:element2.workBenchList[0].benchComponent,
                              path:element2.workBenchList[0].benchPath,
                              name:element2.menuName,
                              icon: element2.menuIcon,
                          })
                          if(index2 === 0){
                              data.redirect = element2.workBenchList[0].benchPath;
                          }
                       })
                       
                       menuData.push(data);

                  }else{//菜单有三级
                      let data = {
                          path:'/p'+index,
                          redirect: '',
                          component: "HomeView",
                          name: element.menuName,
                          icon: element.menuIcon,
                          parent:true,
                          children:[]
                      };
                      element.children.forEach((element2,index2) => {
                          let data2 = {
                              parent:true,
                              component:"Navigation",
                              path:"/home",
                              name:element2.menuName,
                              icon: element2.menuIcon,
                              children:[]
                          }
                          element2.children.forEach((element3,index3) => {
                              if(!element3.workBenchList.length)return;
                              data2.children.push({
                                  pageAddress:element3.workBenchList[0].benchComponent,
                                  path:element3.workBenchList[0].benchPath,
                                  name:element3.menuName,
                                  icon: element3.menuIcon,
                              })
                              if(index2 === 0 && index3 === 0){
                                  data.redirect = element3.workBenchList[0].benchPath;
                              }

                              //拼接三级内页
                              for(let i = 0 ;i < menu.length; i++){
                                  let obj = menu[i];
                                  if(obj.menuId == element.menuId){
                                      for(let j = 0 ;j < obj.children.length; j++){
                                          let obj2 = obj.children[j];
                                          if(obj2.menuId == element2.menuId){
                                              data2.children = data2.children.concat(obj2.children);
                                              break;
                                          }
                                      }
                                  }
                              }
                              // menu.forEach(obj => {
                              //     obj.children.forEach(obj2 => {
                              //         if(obj2.name == element2.menuName && obj.name == element.menuName){
                              //             data2.children = data2.children.concat(obj2.children);
                              //             break;

                              //         }
                              //     })
                              // })

                          })
                          data.children.push(data2);

                      })
                      menuData.push(data);
                  }

                })
                //设置登录之后第一个页面
                if(menuData.length){
                  menuData[0].path = '/';
                }
                //打印页面
                menu.forEach((element,index) => {
                  if(element.hidden && !element.redirect){
                    menuData = menuData.concat(element);
                  }
                })
                
                window.sessionStorage.setItem('userPre',JSON.stringify(menuData))
                let routes = [];
                MenuUtils(routes,menuData)  //  引入组件 和过滤component 
                console.log('routes',routes);           
                
                sessionStorage.token = server_data.data.token
                
                inst.$router.addRoutes(routes);

                inst.hide();
                
                inst.$router.push('/');
                                
                window.location.reload();

            })
            .catch(function (error) {	
                console.log(error);
                inst.$message({
                  message: '似乎网络不可用',
                  type: 'error'
                });
            });

      }
    }
  }

</script>

<style lang="scss" scoped>
  .login-container {
    /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin:0 auto;
    width: 350px;
    padding: 35px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
    .title {
      margin: 0px auto 40px auto;
      text-align: center;
      color: #505458;
    }
    .error-text {
      font-size: 12px;
      color: red;
    }
  }
</style>


// WEBPACK FOOTER //
// ModalLoginWidget.vue?6af158c1